const getTextLength = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return (temp.textContent || '').length;
};

const truncateNode = (node, maxLength, charCount, truncated) => {
    if (truncated) return { node: null, charCount, truncated };

    if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        if (charCount + text.length > maxLength) {
            const remainingChars = maxLength - charCount;
            if (remainingChars > 0) {
                return {
                    node: document.createTextNode(text.substring(0, remainingChars) + '...'),
                    charCount: maxLength,
                    truncated: true
                };
            }
            return { node: null, charCount, truncated: true };
        }
        return { node: node.cloneNode(true), charCount: charCount + text.length, truncated: false };
    } else if (node.nodeType === Node.ELEMENT_NODE) {
        const clone = node.cloneNode(false);
        let currentCharCount = charCount;
        let currentTruncated = truncated;

        for (let i = 0; i < node.childNodes.length && !currentTruncated; i++) {
            const result = truncateNode(node.childNodes[i], maxLength, currentCharCount, currentTruncated);
            if (result.node) {
                clone.appendChild(result.node);
            }
            currentCharCount = result.charCount;
            currentTruncated = result.truncated;
        }
        return { node: clone, charCount: currentCharCount, truncated: currentTruncated };
    }
    return { node: null, charCount, truncated };
};

const truncateHtml = (html, maxLength) => {
    if (!html) return '';

    if (getTextLength(html) <= maxLength) {
        return html;
    }

    const temp = document.createElement('div');
    temp.innerHTML = html;

    let charCount = 0;
    let truncated = false;

    const result = document.createElement('div');
    for (let i = 0; i < temp.childNodes.length && !truncated; i++) {
        const truncateResult = truncateNode(temp.childNodes[i], maxLength, charCount, truncated);
        if (truncateResult.node) {
            result.appendChild(truncateResult.node);
        }
        charCount = truncateResult.charCount;
        truncated = truncateResult.truncated;
    }

    return result.innerHTML;
};

module.exports = {
    getTextLength,
    truncateHtml
};



//////////////////
// WEBPACK FOOTER
// ./Content/scripts/htmlTruncateHelper.js
// module id = 162
// module chunks = 4